///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum AccessorySections {
    'SW_LICENCES',
    'ANTENNA',
    'MK',
    'POWER_INJECTORS',
    'SRG',
    'SFP',
    'MISCELLANEOUS',
    'COMPOSITE'
}
